export default "__VITE_ASSET__8IsaQ2WY__"